module.exports = __webpack_public_path__ + "img/oil-refinery.e7a5e744.png";